export const SubTitleMenuTranslationJP = {
  SubTitleMenu: {
    Title: 'サブタイトルメニュー一覧',
    Detail: 'サブタイトルメニュー詳細　',
    Desc: '※モバイルオーダーの表示名は、<br />日本語以外の言語を選択し、その言語が未設定の場合、<br />英語が表示されます。',
    MenuSettings: '〇メニュー設定',
    RegisterInformation: '〇レジ情報',
    Headers: {
      title: 'ジャンル詳細',
      add: 'ジャンル詳細',
    },
    Filter: {
      order_type: 'サブメニュー属性：',
      only_menu_child: 'サブメニューのみ表示',
      name: 'メニュー名：',
      code: 'メニューコード：',
      filter_delete: '削除データ：',
      hide_record_is_delete: '削除データ非表示',
      include_record_is_delete: '削除データ含めて表示',
      show_record_is_delete: '削除データのみ表示',
      date_of_expiry: '有効期限：',
      Show_valid_dates_below: '以下の日付に有効なものを表示',
    },
    Button: {
      select_all: '全選択',
      cancel_all: '解除',
      reload: 'リロード',
      detail: '詳細',
      delete: '削除',
      search: '絞り込み',
      export_csv: 'キッチンデシャップ通知用メニュー情報CSV出力 </br>（レジ情報除く）',
      import_csv: 'キッチンデシャップ通知用メニュー詳細情報CSV取込',
      link: '※キッチンデシャップ用メニュー詳細情報CSV取込テンプレート',
      restore: '復元',
      keep: '保存',
    },
    Table: {
      selection: '選択',
      code: 'メニューコード',
      name: 'メニュー名',
      type: 'サブメニュー属性',
      start_date: '開始',
      end_date: '終了',
      date_of_expiry: '有効期限',
      pos_code: 'POSコード',
      info: 'レジ情報',
    },
    Form: {
      genre_name: 'ジャンル名',
      select_lunch: 'セレクトランチ',
      image: '画像',
      background: '背景',
      color: '色',
      change: '変更',
      display_name: 'メニュー名',
      japanese: '日本語',
      english: '英語',
      simplified_chinese: '中国語(簡体字)',
      free_group_lunch: '自由组合午餐',
      chinese_traditional: '中国語(繫体字)',
      korean: '韓国語',
      vietnamese: 'ベトナム語',
      remarks: '備考',
      extend: '説明',
      date: '有効期限',
      start_date: '開始',
      end_date: '終了',
      show_name: '表示名',
      register_information_note: '※ レジデータ取込みから取得',
      pos_cd: 'POSコード',
      normal: '通常',
      normal_price: '通常金額（税込み）',
      sub: 'サブ',
      sub_price_inclusive_tax: 'サブ金額（税込み）',
    },
    Validator: {
      name: 'Required name field',
      500: '500 error server',
      success: '成功',
      error: '失敗',
      delete_success: '削除しました',
      add_success: '保存しました',
      max_255: '最大255文字',
      restore_success: '復元しました。',
    },
    PosCode: {
      cd: 'POSコード',
      value: '金額</br>（税込み）</br>※レジデータ取</br>込から取得',
    },
  },
  ModalSearch: {
    title: 'プレビュー',
    language: '言語：',
  },
};
